export enum ExposureLevel {
    private = 'Private',
    partiallyPublic = 'Partial',
    fullyPublic = 'Public',
    unknown = 'Unknown',
}
